import React, { FC, useContext, useEffect, useState } from 'react';

import { TableBody } from '@material-ui/core';

import { GlobalContext } from '../../../../../../../../store';
import { ScoreType } from '../../../../../../../../store/admin/eventFormats/store';
import { IAdminTeamResult } from '../../../../../../../../store/admin/teamResults/store';

import { useAssignResultsState } from '../../../../../Common/AssignResults/Context/AssignResults.context';
import { ScrambleTableRow } from './ScrambleTableRow';
import { useLeaderboardsResults } from '../../../../../../../common/Hooks/useLeaderboardsResults';
import { useGetAdminEvent } from '../../../../../../../../contrib/Hooks/useGetAdminEvent';
import { useRouteInfoState } from '../../../../../../../../components/RouteInfo/Context/RouteInfo.context';

export const ScrambleTableBody: FC = () => {
  const { eventId, roundId } = useRouteInfoState();
  const { selectedCombination, selectedRoundFormat } = useAssignResultsState();

  const {
    actions: {
      adminTeamHoleResults: { get: getAdminTeamHoleResults },
      adminTeamResults: { get: getAdminTeamResults }
    },
    adminTeamResults,
    adminTeamHoleResults
  } = useContext(GlobalContext);

  useEffect(() => {
    getAdminTeamHoleResults(roundId);
  }, [roundId]);

  const [selectedScoreType, setSelectedScoreType] = useState<ScoreType>();
  const [selectedFlightId, setSelectedFlightId] = useState<number>();
  const [formatIsStableford, setFormatIsStableford] = useState(false);

  useEffect(() => {
    if (selectedRoundFormat) {
      setFormatIsStableford(selectedRoundFormat.scoringFormat === 1);
    }
  }, [selectedRoundFormat]);

  const [sortedResults, formattedTeamsHoleResults] = useLeaderboardsResults({
    adminTeamHoleResults,
    adminTeamResults,
    formatIsStableford,
    roundId: Number(roundId),
    selectedFlightId,
    selectedScoreType,
    selectedTeamFormat: 'teamStrokeBetterball'
  });

  const event = useGetAdminEvent(eventId);

  useEffect(() => {
    if (!!roundId) {
      getAdminTeamResults('round', roundId);
    }
  }, [roundId]);

  useEffect(() => {
    if (!!selectedCombination) {
      if (!!selectedCombination.flight) {
        setSelectedFlightId(selectedCombination.flight.id);
      }
      setSelectedScoreType(selectedCombination.scoreType);
    }
  }, [selectedCombination]);

  useEffect(() => {
    if (event && !event.useFlights && event.flights.length > 0) {
      setSelectedFlightId(event.flights[0].id);
    }
  }, [event]);

  return sortedResults.length > 0 ? (
    <TableBody className="results-table-table-body">
      {sortedResults.map((result: IAdminTeamResult, index: number) => (
        <ScrambleTableRow
          key={`${index}-${result.flightId}`}
          result={result}
          selectedScoreType={selectedScoreType}
          formattedTeamsHoleResults={formattedTeamsHoleResults}
        />
      ))}
    </TableBody>
  ) : (
    <></>
  );
};
